import React, { Component } from 'react';
import './ApplicationInfo.css';
import Button from '../../button/Button.jsx';

export class ApplicationInfo extends Component {
    constructor() {
    super()
    this.state = {
        team: [{
            name: "Business",
            desc: "The Business sub-team is tasked with managing sponsorships and partnerships, emailing for new sponsors, organizing events, creating & designing team merch, creating newsletters, improving the website, taking photos & videos for social media, and developing the team’s brand presence. On this sub-team, you can expect to gain hands-on experience in sponsorship relations, event planning, content creation, and brand management. The Business sub-team is looking for students of all years for roles in Photography, Marketing, Sponsorship, Outreach, and Web Dev. Experience in photography, videography, graphic design, video editing, web design, newsletters, and/or event planning is a plus but not required. ",
            //due: "September 9th @ 11:59 PM",
            //link: "https://forms.cloud.microsoft/r/R3EgCj8G79"
          },
         {
            name: "Low Voltage Electronics",
            desc: "The Low Voltage (LV) Electronics team designs, builds, and validates the custom printed circuit boards (PCBs) that monitor and control the low-voltage electrical systems in the car. Our PCBs support critical vehicle functions including vehicle control, startup sequences, sensor inputs, and CAN bus communication. Members will gain hands-on experience taking a board through its full development cycle by designing schematics and PCB layouts in Altium Designer, validating circuitry through SPICE simulations, assembling boards through reflow and hand soldering, and troubleshooting circuits using oscilloscopes, multimeters, and power supplies. Students of all years are encouraged to apply.",
            //due: "September 9th @ 11:59 PM",
            //link: "https://forms.cloud.microsoft/r/bSNe9EPYkL",
          },
         {
            name: "Software",
            richDesc: (
              <>
                <br />
                  
                <strong>Metrics &amp; Observability:</strong> Design a time series database on the cloud, create Grafana dashboards, and write Raspberry Pi scripts to wirelessly collect vehicle sensor data. Used by MAC FE members for debugging. Tech: Databases, Grafana, Go, Python, Raspberry Pi, Wireless Networking
                
                <br />
                  
                <strong>HIL &amp; SIL:</strong> Define firmware tests, improve SIL app, integrate test results with Metrics, run SIL in CI, and extend to HIL testing. Tech: Go, C++, Websockets, Simulink, Speedgoat
                 
                <br />
                  
                <strong>DevOps:</strong> Create GitHub actions, manage devices via scripts and Linux servers. Tech: GitHub, Linux, Ansible
               
                <br />
                  
                <strong>Vehicle Firmware:</strong> Write STM32 C++ firmware for subsystems. Tech: C++, FreeRTOS
                 
                <br />
                  
                <strong>OTA Updates:</strong> Enable wireless firmware updates via CAN + Raspberry Pi. Tech: C++, Linux, CAN
              </>
            ),
            //due: "September 9th @ 11:59 PM",
            //link: "https://forms.cloud.microsoft/r/zapNtRSkz5"
          },
         {
            name: "High Voltage Electronics",
            desc: "The High Voltage (HV) Electronics team designs and builds custom printed circuit boards (PCBs) that interface directly with the car’s HV system which is the heart of the vehicle. As part of the HV sub-team, you'll create circuit schematics and PCB layouts in Altium Designer, assemble PCBs using reflow ovens and hand-soldering, and verify finished boards through in-person testing and SPICE simulations. Collaborating with the other electrical sub-teams, you will explore the full lifecycle of PCB development using industry-standard design tools and laboratory equipment. You will gain critical HV safety, power electronics, and board-level integration knowledge that directly shapes the car’s ability to power up and deliver peak performance. Students of all years are encouraged to apply!",
            //due: "September 9th @ 11:59 PM",
            //link: "https://forms.cloud.microsoft/r/F0eZgDcVF9"
          },
          {
            name: "Wire Harness",
            desc: "The Wire Harness sub-team’s primary responsibility is to design, manufacture, and test the vehicle’s low-voltage wire harness. Our sub-team also designs electrical hardware that do not fall under the scope of other electrical sub-teams. Our work includes working with industry standard software, such as Altium Designer and SolidWorks, operating lab equipment, and developing harness-construction skills. In this role, you’ll have opportunities to collaborate with LV and software sub-teams to test and debug both in the vehicle and on test benches as well as collaborate with mechanical sub-teams to plan harness routing for a reliable, manufacturable, and serviceable design.",
            //due: "September 9th @ 11:59 PM",
            //link: "https://forms.cloud.microsoft/r/E6UVnx8Wet"
          },
          {
            name: "Powertrain Electrical",
            desc: "The Powertrain Electrical team is responsible for the core of the vehicle’s fully electric propulsion system. Our work centers on the design, integration, and validation of the battery pack, inverter, and motors to ensure reliable and efficient power delivery to the drivetrain. As part of this team, you’ll gain hands-on experience with high-voltage systems, power electronics, and performance testing under real racing conditions. You will also gain exposure to battery chemistry and cells, power semiconductors, high-power distribution, and motor development. In this highly cross-functional role, you’ll collaborate closely with the electrical, mechanical, and software teams to integrate the powertrain into the vehicle. All years are encouraged to apply!",
            //due: "September 9th @ 11:59 PM",
            //link: "https://forms.cloud.microsoft/r/vHcyG30gZZ"
          },
          {
            name: "Chassis",
            desc: "Chassis is looking for both upper year and lower year students. Members will utilize and gain experience using SolidWorks to design and model parts such as roll hoops, cooling systems, etc. Additionally, FEA (SolidWorks Sims or Ansys FEA/ACP Pre) will be used to analyze and validate systems to aid in the decision making of our composite layups. Members can expect to be in the workshop for scheduled shifts, helping with the manufacturing of chassis as well as other components of the car.",
            //due: "September 9th @ 11:59 PM",
            //link: "https://forms.cloud.microsoft/r/x5tVFRXthA"
          },
          {
            name: "Human Factors & Ergonomics",
            desc: "As a General Member of the Human Factors and Ergonomics sub-team at Mac Formula Electric, you’ll help design, analyze, and build key driver-focused components such as the dashboard, steering wheel, seat, and headrest. Members gain hands-on experience with SolidWorks and manufacturing, while optimizing designs for safety, comfort, performance, and sub-team integration. You’ll take ownership of a subcomponent, collaborate across teams, and contribute directly to integrating the HFE system into our Formula Electric Vehicle.",
            //due: "September 9th @ 11:59 PM",
            //link: "https://forms.cloud.microsoft/r/mq0DeQD0Nf"
          },
          {
            name: "Drivetrain",
            desc: "As a General Member of the Drivetrain sub-team at Mac Formula Electric, you will have the opportunity to design, analyze, manufacture, and validate components of our in hub geartrain. This season’s focus includes testing, validating, and improving current designs, while also planning for future design cycles. The Drivetrain team welcomes upper and lower-year students. Upper years will focus on designing new systems moving forward while lower years will test and optimize current designs. Members will collaborate closely with other sub-teams, particularly powertrain, on gearbox integration and new powertrain systems moving forward. ",
            //due: "September 9th @ 11:59 PM",
            //link: "https://forms.cloud.microsoft/r/KbpMEVyVvE"
          },
          {
            name: "Suspension",
            desc: "We are looking for students of all years! You will design components by following the engineering process – from research and testing to design, simulation, and manufacturing. Expect to work in a collaborative team environment where your work directly impacts the vehicle’s performance! Experience with CAD (SolidWorks, Inventor, etc.) and a general understanding of DFMA and statics/mechanics is valuable. Knowledge of suspension and steering systems, vehicle dynamics, FEA, and proficiency with MS Suite are a plus, but not required to be considered for this position.",
            //due: "September 9th @ 11:59 PM",
            //link: "https://forms.cloud.microsoft/r/8KAgum8FMa"
          },
          {
            name: "Brakes",
            desc: "The Tires, Brakes & Pedal Tray sub-team is tasked with designing, analyzing, manufacturing, testing, and validating the hydraulic brake and throttle system on the Formula Electric Vehicle. Our team is seeking both upper- and lower-year students, who will be responsible for a subcomponent of the pedal system or developing testing rigs to validate braking dynamics.",
            //due: "September 9th @ 11:59 PM",
            //link: "https://forms.cloud.microsoft/r/vqpC5djjJY"
          },
          {
            name: "Aerodynamics",
            desc: "Our team is seeking both upper- and lower-year students, who will be responsible for subcomponents of the aerodynamics and cooling package, such as a front wing, nosecone, undertray, or radiator ducting. This involves creating and iterating designs, modeling them in SolidWorks, and validating performance using CFD simulations in ANSYS. Members will gain experience in understanding important fluid interactions and properties, while learning how aerodynamics affects other elements of the car, including vehicle dynamics, brakes, and the powertrain. You will work to optimize aerodynamic efficiency by maximizing downforce, minimizing drag, and ensuring cooling devices meet powertrain demands.",
            //due: "September 9th @ 11:59 PM",
            //link: "https://forms.cloud.microsoft/r/TiKt6ietJY"
          },
          {
            name: "Powertrain Mechanical",
            desc: "The powertrain mechanical sub-team is responsible for the design, testing, and physical integration of the accumulator assembly, battery pack design and testing, inverter and cooling, and packaging for electrical systems. The ideal senior mechanical engineer has plenty of good technical background, CAD experience, and experience conducting simulations in Ansys, MATLAB, etc. The ideal candidate also enjoys working with their hands. For lower years, we care about students who are passionate about their technical interests. Someone who can take direction and can also contribute in meaningful non-technical ways by bringing your unique talent to the team.",
            //due: "September 9th @ 11:59 PM",
            //link: "https://forms.cloud.microsoft/r/LURsdQELhh"
          },
          {
            name: "Vehicle Dynamics",
            richDesc: (
              <>
                    The Vehicle Dynamics sub-team is looking for students to help us
                    maximize our racecar’s on-track performance and mechanical grip.
                    In this role, you will bridge the gap between simulation and
                    real-world handling:
                  
                      <br />
                      <br />
                      <strong>Multibody / Parametric Simulation:</strong>{" "}
                      Model suspension kinematics and tire behavior in software like Adams Car
                      to optimize geometry and loads for heave, roll, pitch, and cornering.
                
                      <br />                     
                      <strong>Load Case Analysis:</strong>{" "}
                      Calculate and predict real-world force targets to define structural
                      requirements for chassis, suspension, and steering components.
                
                      <br />                  
                      <strong>Trackside Testing &amp; DAQ:</strong>{" "}
                      Deploy on-car sensors, parse telemetry data, and validate simulation
                      models against real track performance to dial in the optimal setup.
                </>
            ),
            //due: "September 9th @ 11:59 PM",
            //link: "https://forms.cloud.microsoft/r/b6C3VKGvQC"
          },
        ]
      }
    }
  
    render() {

        const { team } = this.state;
        return (
            <div className='application-container'>
              <div className = "application-title-row" >
                <div className = "application-line left" ></div>
                <h1 className = "application-title" > Join the Team </h1> 
                <div className = "application-line right" ></div>
              </div>
                

                {/*
                <div claassName = "general-app-container" >
                      <div className = "team-app-title-container" >
                        <h1 className = "team-app-title" > MECHANICAL </h1>
                      </div>

                      <div className = "general-app-text-container" >
                        <p className = "general-app-desc" > Please complete this form if you are interested in joining the <strong>Mechanical Team</strong> on MAC Formula Electric for the 2025-2026 winter season. Please refer to the role descriptions posted below to learn about the expectations for the sub-team and requirements for candidates. Note that this is a general application. Successful applicants will be placed onto mechanical sub-teams in accordance with sub-team needs. </p> 

                        <p className = "team-app-due" > <strong> Application Due: January 11th @ 11:59 pm </strong> </p>

                        <div className = "team-app-apply-button" >
                          <a 
                            href="https://forms.office.com/pages/responsepage.aspx?id=B2M3RCm0rUKMJSjNSW9Hcn7RPYdPNDxGp5QTbXGGiBtUOVBHRTI2SVNPMEMzU1g0T0s4SkhPWEsyWC4u&route=shorturl" 
                            style={{ textDecoration:'none', paddingLeft:'10px'}}
                            target="_blank" rel="noopener noreferrer">
                              <button type="button" className="apply-btn">
                                Apply Now
                              </button>
                          </a> 
                        </div>
                      </div>
                    </div>
                */}
                <div className = "team-app-container" >

                    
                  
                    {team.map((team) => ( 
                      <div className = "team-apps-container" key={team.name}>
                        <div className = "team-app-title-container" >
                          <h1 className = "team-app-title" > {team.name} </h1> 
                        </div>
                        <div className = "team-app-text-container" >
                          <p className = "team-app-desc" > <strong> Description: </strong>{team.richDesc ?? team.desc} </p> 
                          
                            {/*<p className = "team-app-due" > 
                              <strong> Application Due: {team.due} </strong> 
                          </p>*/}
                          
                          {/*team.link && (
                            
                            <div className = "team-app-apply-button" >
                              <a 
                                href={team.link} 
                                style={{ textDecoration:'none', paddingLeft:'10px'}}
                                target="_blank" rel="noopener noreferrer">
                                  <button type="button" className="apply-btn">
                                    Apply Now
                                  </button>
                              </a> 
                            </div>
                          )*/}


                          {/*{team.name === "Electrical" && (
                            <div className = "team-app-apply-button" >
                              <a 
                                href={team.subteamDesc} 
                                style={{ textDecoration:'none', paddingLeft:'10px'}}
                                target="_blank" rel="noopener noreferrer">
                                  <button type="button" className="apply-btn">
                                    Sub-Team Description
                                  </button>
                              </a> 
                            </div>
                          )}*/}
                          
                        </div> 
                    </div>
                    ))
                  } 

                  
                </div> 
                <div className='footer-spacer' />
            </div>
        )
    }
}

export default ApplicationInfo
